import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Dropdown from 'views/ui/form_elements/dropdown';
import SessionStore from 'stores/shared/session';
import nav from 'actions/app';

const SessionLanguageChooser = createReactClass({
  mixins: [PureRenderMixin],
  displayName: 'SessionLanguageChooser',
  // These are supported lang - eventually place in a config
  languages: {
    'es-ES': 'Español',
    'sv-SE': 'Svenska',
    'ja-JP': '日本語',
    'fr-CA': 'Français',
    'fr-FR': 'Français',
    'de-DE': 'German',
    'nl-NL': 'Nederlands',
    'zh-CN': 'Chinese',
    'el-GR': 'Greek',
    'it-IT': 'Italian',
  },

  getDefaultProps() {
    return {
      supportedLanguages: [],
    };
  },

  getInitialState() {
    return { selectedLanguage: 'en-EN' };
  },

  languageDidChange(name, newLanguage) {
    let url = new URL(window.location);
    url.searchParams.set('lang', newLanguage);

    window.location = url.href;
  },

  buildOptions() {
    const langOptions = { 'en-US': 'English' };
    for (const lang of this.props.supportedLanguages) {
      if (this.languages[lang]) {
        langOptions[lang] = this.languages[lang];
      }
    }
    return langOptions;
  },

  render() {
    const dropdownProps = {
      name: 'session-language',
      value: this.props.initialLanguage || SessionStore.state.get('i18n'),
      options: this.buildOptions(),
      defaultOption:
        this.props.initialLanguage || SessionStore.state.get('i18n'),
      onChange: this.languageDidChange,
    };
    if (this.props.icon) {
      dropdownProps.icon = this.props.icon;
    }
    if (this.props.supportedLanguages.filter((l) => l !== '').length === 0) {
      return null;
    }
    return (
      <div className="CurrencyDropdown LanguageDropdown">
        <Dropdown {...dropdownProps} />
      </div>
    );
  },
});

export default SessionLanguageChooser;
